import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const { data } = await api.post("/admin/login", form);
      localStorage.setItem("qc_admin_token", data.token);
      nav("/admin/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#0B3D2E] grid place-items-center px-5 relative overflow-hidden">
      <div className="absolute inset-0 qc-grid-bg opacity-30" />
      <div className="absolute -top-20 -right-20 h-96 w-96 rounded-full bg-emerald-500/20 blur-3xl" />
      <div className="relative w-full max-w-sm">
        <div className="flex items-center gap-2.5 justify-center mb-8">
          <span className="grid place-items-center h-10 w-10 rounded-xl bg-white/10 text-emerald-400"><ShieldCheck size={22} /></span>
          <span className="font-display font-semibold text-xl text-white">Quantum Cover</span>
        </div>
        <form onSubmit={submit} className="bg-white rounded-3xl p-8 shadow-2xl">
          <h1 className="font-display text-2xl font-semibold text-[#0B3D2E] flex items-center gap-2"><Lock size={20} /> Admin Login</h1>
          <p className="text-sm text-slate-500 mt-1">Sign in to view leads and bookings.</p>
          <div className="mt-6 space-y-4">
            <div><Label className="text-sm">Email</Label><Input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="admin-email" className="mt-1.5 rounded-xl h-12" /></div>
            <div><Label className="text-sm">Password</Label><Input required type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="admin-password" className="mt-1.5 rounded-xl h-12" /></div>
          </div>
          {error && <p className="mt-4 text-sm text-red-600" data-testid="admin-error">{error}</p>}
          <Button type="submit" disabled={loading} data-testid="admin-login-submit" className="mt-6 w-full rounded-full bg-emerald-600 hover:bg-emerald-700 text-white py-6">{loading ? "Signing in…" : "Sign in"}</Button>
        </form>
      </div>
    </div>
  );
}
